module.exports = __webpack_public_path__ + "img/why_australians_play_video_games_splash.5faee024.jpg";